import { useGetUserNameById } from '~/features/leadDetails/hooks/useGetUserNameById';

export const useUserDisplayName = (userId?: string) => {
    const data = useGetUserNameById(userId);

    if (!data) {
        return undefined;
    }

    return `${data.firstName} ${data.lastName}`;
};
